/**
 * zh-HK 基線字典（書面語版）
 * ⚠️ 全站 zh 文案一律書面中文（Captain 2026-09-16 定稿標準）：
 *    禁口語字（好似／唔／嘅／係／屙／定 etc.）；引錄李小龍原話可保留原味。
 * 其他語言檔型別必須為 Dict（來自本檔 typeof 推導）——缺鍵＝編譯錯誤。
 */
export default {
  // Site meta（<title>／meta description，跟語言切換同步）
  'meta.title': 'JKD Coding｜以無法為有法 — AI 商業顧問',
  'meta.description': 'JKD Coding 融合李小龍截拳道哲學，為 NGO、社企與中小企提供 AI 轉化診斷、增長系統設計與客戶關係營運。30 分鐘診斷，找出 AI 最自然的介入點。',

  // Navbar
  'nav.arsenal': '現成方案',
  'nav.components': '元件庫',
  'nav.custom': '全訂製項目',
  'nav.philosophy': '方法論',
  'nav.consult': '免費諮詢',

  // Hero
  'hero.kicker': 'Be Water, My Friend',
  'hero.titleA': '如水之智',
  'hero.titleB': '快狠準解決商業問題',
  'hero.subtitle': 'JKD Coding 為 NGO、社企與中小企設計 AI 轉化系統：不強加技術，只為你的業務找到最自然的形態，讓捐贈增長、客戶保留與現金流預警一次到位。',
  'hero.cta': '預約 AI 轉化診斷',
  'hero.approach': '了解我們的方法',
  'hero.quote': '清空你的腦袋，無形無狀，如水一般。',

  // Services
  'services.tag': '我們的服務領域',
  'services.title': '不是賣工具，是解決問題',
  'services.subtitle': '每個專案都從你的商業瓶頸出發，再決定 AI 該以什麼形態介入。',
  'services.m1.eyebrow': '01 / 增長',
  'services.m1.title': '捐贈者與客戶增長',
  'services.m1.problem': '潛在支持者來了卻不轉化，獲客成本越來越高。',
  'services.m1.solution': '設計 AI 驅動的轉化漏斗，把每一次互動變成長期關係的起點。',
  'services.m1.result': '提升轉化率，降低獲客成本',
  'services.m2.eyebrow': '02 / 關係',
  'services.m2.title': '客戶關係營運',
  'services.m2.problem': '跟進遺漏、回覆太慢、客戶漸漸冷卻。',
  'services.m2.solution': '把一對一溝通變成可預測、可規模的關係營運系統。',
  'services.m2.result': '減少流失，提升回頭率',
  'services.m3.eyebrow': '03 / 風險',
  'services.m3.title': '現金流與風險預警',
  'services.m3.problem': '壞帳發生後才發現，客戶轉投對手才察覺。',
  'services.m3.solution': 'AI 每日監察行為訊號，在風險發生前主動提醒你。',
  'services.m3.result': '保護現金流，提前應對風險',
  'services.m4.eyebrow': '04 / 採用',
  'services.m4.title': '變革採用與營運效率',
  'services.m4.problem': '系統上線，員工卻不願意用，培訓成本高。',
  'services.m4.solution': '從習慣出發設計採用路徑，讓改變自然發生。',
  'services.m4.result': '提升採用率，減少操作錯誤',
  'services.m5.eyebrow': '05 / 知識',
  'services.m5.problem': '會議開完，經驗就跟著蒸發。',
  'services.problemLabel': '常見問題',
  'services.solutionLabel': '我們的做法',
  'services.cta': '預約一次無壓力的業務診斷',

  // Arsenal
  'arsenal.tag': 'READY-TO-DEPLOY',
  'arsenal.title': '現成方案',
  'arsenal.subtitle': '場景化解決方案封裝，快速部署，即戰即用',
  'arsenal.blindbox.title': '盲盒系統',
  'arsenal.blindbox.subtitle': '季節性行銷神器',
  'arsenal.blindbox.desc': '概率配置引擎、獎品庫管理、社交擴散機制、數據追蹤面板。適合 NGO 籌款、電商促銷、KOL 互動。',
  'arsenal.blindbox.f1': '季節版本主題（CNY/聖誕/中秋）',
  'arsenal.blindbox.f2': '自定義概率與保底機制',
  'arsenal.blindbox.f3': '社交分享解鎖功能',
  'arsenal.blindbox.f4': '完整數據分析面板',
  'arsenal.blindbox.f5': '30 分鐘視訊支援',
  'arsenal.whatsapp.title': 'WhatsApp 客製化自動跟進系統',
  'arsenal.whatsapp.subtitle': '客戶關係引擎',
  'arsenal.whatsapp.desc': '靈活預配置工作流，支援棄置購物車、訂單更新、預約確認、滿意度調查。',
  'arsenal.whatsapp.f1': '預設訊息模板庫',
  'arsenal.whatsapp.f2': '聊天機器人配置',
  'arsenal.whatsapp.f3': 'CRM 系統整合',
  'arsenal.whatsapp.f4': '30 分鐘內部署完成',
  'arsenal.whatsapp.f5': '持續技術支援',
  'arsenal.promise': '10 分鐘 擁有你的轉化漏斗',
  'arsenal.priceFrom': '起',

  // Products
  'products.tag': 'NEW RELEASES',
  'products.title': 'AI 業務工具',
  'products.subtitle': '專為中小企設計的 AI 業務助手，立即體驗互動式演示。',
  'products.cta': '立即體驗',
  'products.landlink.title': 'Landlink',
  'products.landlink.subtitle': 'AI 習慣落地助手',
  'products.landlink.desc': '專門解決「系統上線，員工/客戶卻不肯用」的問題。AI 讀取舊有操作習慣，主動準備最常用的工作，把繁瑣流程濃縮成一步。',
  'products.landlink.f1': '讀取舊習慣，預先準備下一步',
  'products.landlink.f2': '管理層採用進度摘要 + 每日 WhatsApp 提醒',
  'products.landlink.f3': '前線個人積分與一鍵重複操作',
  'products.landlink.f4': '把五步變一步，降低培訓與出錯成本',
  'products.bizpulse.title': 'Bizpulse',
  'products.bizpulse.subtitle': 'AI 客戶風險監察員',
  'products.bizpulse.desc': '24 小時監察客戶行為，提早發現拖欠帳款、客戶流失、轉投對手等風險。讓你在壞帳發生前主動出擊，保住現金流。',
  'products.bizpulse.f1': 'AI 每日巡查客戶紀錄',
  'products.bizpulse.f2': '自動識別付款變慢與互動冷卻',
  'products.bizpulse.f3': '即時風險預警通知',
  'products.bizpulse.f4': '無需學 AI，開箱即用',

  // Components
  'components.tag': 'COMPONENTS LIBRARY',
  'components.title': '元件庫',
  'components.subtitle': '模組化能力開放，按需組合，技術自主',
  'components.quote': '"想都是問題，做才有答案"',
  'components.scroll.name': '滾動觸發動畫模組',
  'components.scroll.tech': 'Intersection Observer API',
  'components.scroll.desc': '支援淡入、滑入、縮放、旋轉等 12 種動效，可配置觸發閾值和延遲',
  'components.i18n.name': '雙語 i18n 架構',
  'components.i18n.tech': 'URL 參數 / 瀏覽器偵測',
  'components.i18n.desc': '基於 URL 參數或瀏覽器語言自動偵測的內容切換系統，支援 RTL 語言預留',
  'components.cf-track.name': 'Cloudflare Workers 追蹤',
  'components.cf-track.tech': 'Serverless',
  'components.cf-track.desc': '無伺服器架構的用戶行為追蹤，支援自訂事件、用戶分群、與 GA4 雙軌並行',
  'components.cf-webhook.name': 'Cloudflare Workers Webhook',
  'components.cf-webhook.tech': 'HTTP Endpoints',
  'components.cf-webhook.desc': '標準化 HTTP 端點，支援請求驗證、速率限制、與 Zapier/Make 整合',
  'components.og.name': 'OG 標籤優化套件',
  'components.og.tech': 'Dynamic Meta Tags',
  'components.og.desc': '動態 Open Graph 標籤生成，支援 A/B 測試和社交媒體預覽模擬',
  'components.full.title': '元件庫全庫',
  'components.full.desc': '包含所有元件 + 優先支援通道 + 季度更新訂閱，適合需要系統性技術能力的中大型項目',
  'components.full.tag1': '全部元件',
  'components.full.tag2': '優先支援',
  'components.full.tag3': '季度更新',
  'components.perYear': '/年',
  'components.orMonthly': '或 HK$200/月',

  // Custom
  'custom.tag': 'CUSTOM DOJO',
  'custom.title': '全訂製項目',
  'custom.subtitle': '全訂製轉化漏斗，從零到一，打造獨一無二的轉化機器',
  'custom.price': '項目報價',
  'custom.priceNote': '根據項目範圍與複雜度定制',
  'custom.ctaNote': '無需承諾，先了解你的業務需求',
  'custom.phase1.week': 'Week 1',
  'custom.phase1.title': '競品研究與機會識別',
  'custom.phase1.desc': '系統性拆解 5–10 個頂尖競品：熱圖逆向工程、性能評分、SEO 關鍵詞重疊',
  'custom.phase1.deliverable': '轉化差距分析報告',
  'custom.phase2.week': 'Week 1–2',
  'custom.phase2.title': '文案策略與信息架構',
  'custom.phase2.desc': 'Jobs-to-be-Done 用戶訪談、主標題 10 變體、社會證明策略、CTA 動詞優化',
  'custom.phase2.deliverable': '文案策略手冊',
  'custom.phase3.week': 'Week 2–4',
  'custom.phase3.title': 'UI/UX 設計與原型驗證',
  'custom.phase3.desc': '雙軌衝刺模式、Figma 高保真可交互原型、真實設備測試',
  'custom.phase3.deliverable': '可點擊原型 + 設計規範',
  'custom.phase4.week': 'Week 4–6',
  'custom.phase4.title': '技術開發與部署',
  'custom.phase4.desc': '用戶界面（UI）視覺層構建、JSON 邏輯配置、Cloudflare Workers 邊緣部署',
  'custom.phase4.deliverable': '生產環境網站',
  'custom.phase5.week': 'Week 6–8',
  'custom.phase5.title': '數據追蹤與優化',
  'custom.phase5.desc': 'GA4 流量分析、Hotjar 行為熱圖、A/B 測試框架、自定義轉化儀表板',
  'custom.phase5.deliverable': '數據監測報告',
  'custom.cta': '預約免費諮詢',

  // Philosophy
  'philosophy.tag': 'PHILOSOPHY',
  'philosophy.title': '方法論',
  'philosophy.subtitle': 'Vibe-coding 方法論，授人以漁的高階知識產品',
  'philosophy.pillar1.title': '截拳道哲學基礎',
  'philosophy.pillar1.desc': '李小龍「以無法為有法」思想與現代敏捷開發的深度對話，探索武術智慧如何轉化為數碼開發心法',
  'philosophy.pillar2.title': 'RPE 方法論框架',
  'philosophy.pillar2.desc': 'Rapid Prototyping & Execution 快速原型與執行完整操作手冊：需求訪談、原型工具選擇、用戶測試、迭代節奏',
  'philosophy.pillar3.title': '工具評測與實戰',
  'philosophy.pillar3.desc': 'Bubble、Webflow、Framer 等零代碼/低代碼平台深度評測，不迴避缺點，建立客觀權威',

  // FAQ（GEO：問句標題 + 每題一段直接答案，同步 FAQPage JSON-LD）
  'faq.tag': 'FAQ',
  'faq.title': '常見問題',
  'faq.subtitle': '關於 JKD Coding 服務的最直接解答',
  'faq.q1': '你們為哪類機構服務？',
  'faq.a1': '我們專為 NGO、社會企業與中小企服務。無論是捐贈者增長、客戶關係營運，還是現金流風險預警，我們都從你的實際業務問題出發設計方案。',
  'faq.q2': 'AI 轉化診斷是什麼？會發生什麼事？',
  'faq.a2': '這是一次 30 分鐘的一對一顧問對談。我們會釐清你目前最大的業務瓶頸，並找出 AI 最自然的介入點；對談後你會收到具體的改善建議，過程無任何銷售壓力。',
  'faq.q3': '收費如何計算？',
  'faq.a3': '現成方案 HK$800 起（盲盒系統）、WhatsApp 自動跟進系統 HK$1,500 起；元件庫單項 HK$300–800，全庫訂閱 HK$2,000/年；全訂製項目按範圍報價，一般為 HK$15,000–50,000。',
  'faq.q4': '多久可以上線？',
  'faq.a4': '現成方案最快 30 分鐘完成部署；元件庫按需組合，通常數天內交付；全訂製項目按五個階段推進，一般 6–8 週完成並部署上線。',
  'faq.q5': '我們不懂技術，可以合作嗎？',
  'faq.a5': '完全可以。技術細節由我們處理，你只需要說出業務目標。所有查詢在 24 小時內回覆，方案確認後亦有持續技術支援。',
  'faq.author': '作者：JKD Coding 團隊',
  'faq.updated': '更新於 2026 年 9 月',

  // Contact
  'contact.tag': 'GET IN TOUCH',
  'contact.title': '開始你的旅程',
  'contact.subtitle': '「人生……就像大便一樣，有時軟、有時硬；有時順暢，有時不順暢！」',
  'contact.form.title': '發送訊息',
  'contact.form.name': '姓名',
  'contact.form.namePlaceholder': '你的姓名',
  'contact.form.email': '電郵',
  'contact.form.emailPlaceholder': 'your@email.com',
  'contact.form.business': '業務類型',
  'contact.form.businessPlaceholder': '選擇你的業務類型',
  'contact.form.businessNgo': 'NGO / 社企',
  'contact.form.businessSme': '中小企',
  'contact.form.businessPersonal': '個人品牌',
  'contact.form.businessOther': '其他',
  'contact.form.message': '訊息',
  'contact.form.messagePlaceholder': '簡單描述你的需求或問題...',
  'contact.form.submit': '發送訊息',
  'contact.form.processing': '處理中...',
  'contact.form.waNote': '下一步需要透過 WhatsApp 驗證身份，請確保你能夠使用 WhatsApp。',
  'contact.verify.title': '驗證你的 WhatsApp',
  'contact.verify.desc': '請點擊下方按鈕打開 WhatsApp，發送驗證訊息以完成提交。',
  'contact.verify.codeLabel': '你的驗證碼 Your Verification Code',
  'contact.verify.openWa': '打開 WhatsApp 驗證 / Open WhatsApp',
  'contact.verify.prefillNote': '驗證訊息將自動填入 Verification message will be pre-filled',
  'contact.verify.back': '← 返回修改資料 / Go Back',
  'contact.success.title': '驗證成功！',
  'contact.success.desc': '我們已收到你的查詢，會在 24 小時內回覆你。',
  'contact.quick.title': '快速聯絡',
  'contact.quick.whatsapp': 'WhatsApp 諮詢',
  'contact.quick.whatsappDesc': '即時回覆，預約免費諮詢',
  'contact.quick.response': '快速回應承諾',
  'contact.quick.responseDesc': '所有查詢 24 小時內回覆',
  'contact.promise': '「無論你是 NGO、社企還是中小企，我們都會用最直接的方式，為你找到最合適的解決方案。無需擔心技術細節，只要說出你的業務目標即可。」',
  'contact.promiseAuthor': '— JKD Coding 團隊',
  'contact.alertFail': '提交失敗，請重試或直接 WhatsApp 聯絡我們。',
  'contact.waPrefill': '你好！我想了解 JKD Coding 的服務。',

  // Footer
  'footer.desc': '融合李小龍截拳道哲學，以「無法為有法」作為核心創新思維，為 NGO、社企、中小企打造轉化漏斗。',
  'footer.products': '產品',
  'footer.content': '內容',
  'footer.about': '關於',
  'footer.aboutUs': '關於我們',
  'footer.contact': '聯絡',
  'footer.faq': '常見問題',
  'footer.privacy': '私隱政策',
  'footer.terms': '服務條款',
  'footer.rights': 'All rights reserved.',
  // Diagnostic share card（P0 裂變入口）
  'share.title': '推薦給一位朋友',
  'share.desc': '知道有企業正被系統採用問題困擾？把免費診斷分享給對方。',
  'share.copy': '複製連結',
  'share.copied': '已複製！',
  'share.whatsapp': '透過 WhatsApp 分享',
  'share.more': '更多分享方式',
  'share.prefill': '一位朋友推薦我試試 JKD Coding 的免費 AI 轉化診斷（30 分鐘，無銷售壓力）：',

  // Diagnostic page（/diagnosis）
  'diag.tag': '30 分鐘策略對談',
  'diag.title': 'AI 轉化診斷',
  'diag.subtitle': '30 分鐘，釐清你的業務瓶頸，並找出 AI 最自然的介入點。',
  'diag.back': '返回主頁',
  'diag.step1Title': '先了解你的處境',
  'diag.step1Desc': '填寫後，我們的顧問會在 1 個工作天內與你聯絡。',
  'diag.name': '姓名 *',
  'diag.organization': '機構名稱 *',
  'diag.role': '職位 *',
  'diag.email': '電郵 *',
  'diag.businessType': '業務類型 *',
  'diag.businessPlaceholder': '請選擇',
  'diag.ngo': 'NGO / 社企',
  'diag.sme': '中小企',
  'diag.personal': '個人品牌',
  'diag.other': '其他',
  'diag.challenge': '目前最大的轉化挑戰是什麼？ *',
  'diag.challengePlaceholder': '請選擇',
  'diag.challenge1': '潛在客戶來了但不轉化',
  'diag.challenge2': '客戶跟進遺漏或回覆太慢',
  'diag.challenge3': '壞帳或客戶流失風險難以預警',
  'diag.challenge4': '新系統上線後團隊不願使用',
  'diag.challenge5': '內容產能不足，難以持續溝通',
  'diag.goals': '希望優先解決的商業目標 *',
  'diag.goalsPlaceholder': '簡單描述你希望達成的結果，例如：提升捐款完成率 30%',
  'diag.budget': '可接受的預算範圍（可選）',
  'diag.budgetPlaceholder': '請選擇',
  'diag.budget1': 'HK$8,000 – 20,000',
  'diag.budget2': 'HK$20,000 – 50,000',
  'diag.budget3': 'HK$50,000 – 150,000',
  'diag.budget4': 'HK$150,000+',
  'diag.privacy': '你的資料僅用於本次對談安排，絕不轉售。',
  'diag.submit': '預約我的專屬診斷',
  'diag.submitting': '處理中...',
  'diag.verifyTitle': '驗證你的 WhatsApp',
  'diag.verifyDesc': '請點擊下方按鈕打開 WhatsApp，發送驗證訊息以完成預約。',
  'diag.code': '你的驗證碼',
  'diag.openWhatsApp': '打開 WhatsApp 驗證',
  'diag.prefilled': '驗證訊息將自動填入',
  'diag.goBack': '返回修改資料',
  'diag.successTitle': '驗證成功！',
  'diag.successDesc': '我們已收到你的診斷申請，會在 24 小時內回覆你。',
  'diag.alertFail': '提交失敗，請重試。',
  'diag.msgOrg': '機構名稱',
  'diag.msgRole': '職位',
  'diag.msgChallenge': '目前最大挑戰',
  'diag.msgGoals': '希望優先解決的目標',
  'diag.msgBudget': '可接受預算範圍',
  'diag.msgUnfilled': '未填寫',
  // Landlink（/landlink）
  'landlink.brandName': '落地通',
  'landlink.backAria': '返回首頁',
  'landlink.brandAria': '落地通 LandLink',
  'landlink.zero.kicker': 'AI 習慣落地助手',
  'landlink.zero.titleA': '系統上線了，',
  'landlink.zero.titleB': '員工／客戶不肯用？',
  'landlink.zero.body': '落地通讀取舊有操作，主動準備最常用的工作，',
  'landlink.zero.bodyStrong': '將五步變一步。',
  'landlink.zero.cta': '先看阻力在哪裡',
  'landlink.zero.dashLabel': 'ADOPTION RATE',
  'landlink.one.kicker': 'AI 正在替你拆解採用阻力',
  'landlink.one.title': '技術已上線，習慣未必。',
  'landlink.one.body': '按下 3 個訊號，看看員工或客戶不用系統的真正原因。',
  'landlink.one.closeAria': '關閉',
  'landlink.one.continueNext': '繼續查看下一個訊號 →',
  'landlink.one.continueDone': '查看 AI 如何接手 →',
  'landlink.one.progressPre': '已查看',
  'landlink.one.progressPost': '個訊號',
  'landlink.one.f1.eyebrow': '行為阻力：熟悉感',
  'landlink.one.f1.title': '舊方法，零思考成本',
  'landlink.one.f1.text': '紙筆已經變成本能；新系統就算只多一步，也會在最忙的時候被放棄。問題不在功能，而在轉換習慣的成本。',
  'landlink.one.f2.eyebrow': '行為阻力：出錯恐懼',
  'landlink.one.f2.title': '前線害怕按錯',
  'landlink.one.f2.text': '當操作結果不夠清晰，前線人員會選擇最安全的舊路。需要的不是再一次培訓，而是即時、確定的回饋。',
  'landlink.one.f3.eyebrow': '行為阻力：缺乏回報',
  'landlink.one.f3.title': '轉變與我無關',
  'landlink.one.f3.text': '公司得到效率，前線卻只感受到麻煩。把回報落到個人身上，採用才會由要求變成主動選擇。',
  'landlink.two.kicker': 'AI Agent 不是概念・現在看他真正做事',
  'landlink.two.titlePre': '5 步變 ',
  'landlink.two.titleHighlight': '1 步',
  'landlink.two.titlePost': '。',
  'landlink.two.body': '同一張單，兩種做法。落差就是員工／客戶每天面對的選擇。',
  'landlink.two.startHint': '按下開始，親眼看 AI 如何用舊習慣把五步濃縮成一個動作。',
  'landlink.two.startCta': '開始對比',
  'landlink.two.classicLabel': '傳統做法',
  'landlink.two.classicStepsLabel': '5 個步驟',
  'landlink.two.step1': '開啟訂單系統',
  'landlink.two.step2': '逐項選擇菜式',
  'landlink.two.step3': '輸入數量與規格',
  'landlink.two.step4': '核對送貨資料',
  'landlink.two.step5': '確認送出',
  'landlink.two.orderLabel': '示例訂單',
  'landlink.two.orderItem': '🥬 白菜 × 2',
  'landlink.two.aiLabel': 'AI 做法',
  'landlink.two.aiStepsLabel': '1 個動作',
  'landlink.two.aiReadyLabel': 'AI 預先準備',
  'landlink.two.aiOrder': '🥬 白菜 × 2・送到中環店・今天上午',
  'landlink.two.evidenceIntro': '根據過往使用習慣',
  'landlink.two.ev1.label': '最近 4 次訂單',
  'landlink.two.ev1.value': '全部是白菜 × 2',
  'landlink.two.ev2.label': '常用送貨地點',
  'landlink.two.ev2.value': '中環店・9 次',
  'landlink.two.ev3.label': '星期一習慣',
  'landlink.two.ev3.value': '通常上午 10 時補貨',
  'landlink.two.confirm': '照舊這張單・確認送出',
  'landlink.two.confirmed': '已確認送出',
  'landlink.two.aiNote': 'AI 只調用已授權的公司紀錄，每個建議都有來源。',
  'landlink.three.titlePre': '不是叫人改變，',
  'landlink.three.titleMid': '是讓改變',
  'landlink.three.titleHighlight': '值得',
  'landlink.three.titlePost': '。',
  'landlink.three.body': '動機、能力與提示缺一不可。落地通從管理與前線兩端同時降低阻力、增加回報。',
  'landlink.three.cta': '開始對話',
  'landlink.three.card1.title': '管理層｜由上而下推動',
  'landlink.three.card1.copy': '讓管理者看見採用進度，並擁有每天主動提醒的依據。',
  'landlink.three.card2.title': '前線層｜誘因落到個人',
  'landlink.three.card2.copy': '把新系統變成更快、更輕鬆，而且值得每天打開的選擇。',
  'landlink.four.kicker': '讓系統真正落地',
  'landlink.four.titlePre': '下一個被改變的，',
  'landlink.four.titleMid': '可以是',
  'landlink.four.titleHighlight': '你的系統',
  'landlink.four.titlePost': '。',
  'landlink.four.body': '告訴我們你正在推動的系統，我們會找出最值得先處理的一步。',
  'landlink.four.ctaLoading': '正在連接顧問…',
  'landlink.four.cta': 'WhatsApp 免費了解',
  'landlink.four.note': '無需電腦知識 · 專人為你講解',
  'landlink.four.waPrefill': '您好，我想了解落地通 AI 習慣落地助手。',

  // Bizpulse（/bizpulse）
  'bizpulse.brandName': '商脈',
  'bizpulse.backAria': '返回首頁',
  'bizpulse.title': '請一位永不偷懶的 AI 風控員',
  'bizpulse.kicker': 'AI 客戶風險監察',
  'bizpulse.heroBody': '24 小時替你盯實每位客戶。',
  'bizpulse.heroStrong': '誰可能拖欠、流失、轉投對手，AI 先一步通知你。',
  'bizpulse.heroCta': '看看 AI 如何替我盯客',
  'bizpulse.scanLabel': 'AI 正在替你巡查客戶',
  'bizpulse.one.title': '風險未發生，AI 已看見。',
  'bizpulse.one.body': '按下 3 個紅色警號，看看 AI 可以提早發現什麼。',
  'bizpulse.one.closeAria': '關閉',
  'bizpulse.one.continueNext': '繼續查看下一個警號 →',
  'bizpulse.one.continueDone': '查看 AI 風控員如何工作 →',
  'bizpulse.one.progressPre': '已查看',
  'bizpulse.one.progressPost': '個警號',
  'bizpulse.one.s1.title': '可能拖欠',
  'bizpulse.one.s1.tag': 'AI 發現：付款開始變慢',
  'bizpulse.one.s1.detail': '這位客戶的付款日一再推遲。AI 會在變成壞帳之前提醒你，讓你及早跟進、保住現金流。',
  'bizpulse.one.s2.title': '可能流失',
  'bizpulse.one.s2.tag': 'AI 發現：客戶正在冷卻',
  'bizpulse.one.s2.detail': '查詢少了、回覆慢了、互動也降了。AI 每日替你監察，讓你在客戶離開前主動挽留。',
  'bizpulse.one.s3.title': '可能轉投對手',
  'bizpulse.one.s3.tag': 'AI 發現：落單習慣改變',
  'bizpulse.one.s3.detail': '訂單次數和數量開始反常。AI 會找出這些細微變化，提醒你把握最後的跟進機會。',
  'bizpulse.two.step1.title': '接駁紀錄',
  'bizpulse.two.step1.copy': '集中客戶資料',
  'bizpulse.two.step2.title': 'AI 每日巡查',
  'bizpulse.two.step2.copy': '找出反常行為',
  'bizpulse.two.step3.title': '即時報警',
  'bizpulse.two.step3.copy': '直接告知風險',
  'bizpulse.two.step4.title': '及早跟進',
  'bizpulse.two.step4.copy': '保住生意與現金',
  'bizpulse.two.finalSmall': '你的 AI 風控員',
  'bizpulse.two.titlePre': '不用學 AI。',
  'bizpulse.two.titleHighlight': 'AI 自動替你盯客。',
  'bizpulse.two.finalBody': '每日巡查、不會偷懶；一有風險，立即通知你。',
  'bizpulse.two.ctaLoading': '正在連接顧問…',
  'bizpulse.two.cta': 'WhatsApp 免費了解',
  'bizpulse.two.note': '無需電腦知識 · 專人為你講解',
  'bizpulse.two.waPrefill': '您好，我想了解如何請一位 AI 風控員替我監察客戶風險。',

  // Promo（/promo）
  'promo.kicker': '地產代理 × 社交媒體自動化',
  'promo.titlePre': '物業更新、發帖、追數據',
  'promo.titleHighlight': '一個系統，一次搞定。',
  'promo.heroLead': '新盤一入庫，10 秒變成一則專業 FB 貼文——自動浮水印防盜、自動短連結追蹤、自動統計哪個盤最搶手。',
  'promo.heroBold': '「照片轉影片」',
  'promo.heroTail': '，用最小的精力，做到最佳的客戶體驗。',
  'promo.videoCaption': '▲ 實機演示：物業資料 → 一鍵生成專業影片（自動配樂、字幕、聯絡卡、QR）',
  'promo.ctaDemo': 'WhatsApp 立即預約 Demo',
  'promo.ctaTry': '線上親自試玩',
  'promo.waPrefill': '我想了解物業社群同步方案',
  'promo.painTitle': '地產代理每天面對的三件事',
  'promo.pain1.t': '盤源日日變',
  'promo.pain1.d': '新盤、租出、售出——更新完網站，還要人手再發一次社交媒體，兩邊奔波',
  'promo.pain2.t': '相片一上網就被人盜',
  'promo.pain2.d': '辛苦拍攝的盤相，轉頭被人下載使用，連 AI 修圖都防不住',
  'promo.pain3.t': '廣告費花了如流水',
  'promo.pain3.d': '出了帖不知道哪個盤有人看、多少人點擊，沒數據等於沒方向',
  'promo.stepsTitlePre': '由盤源到貼文，',
  'promo.stepsTitleHighlight': '三步、十秒',
  'promo.stepsNote': '以下為系統真實操作畫面，不是概念圖',
  'promo.screenshotAlt': '系統操作實景：社群推廣區',
  'promo.screenshotCaption': '▲ 後台實景：勾選相片 → 文案自動生成（可複製編輯）→ 一鍵發佈，貼文即時上 FB',
  'promo.step1.t': '選相',
  'promo.step1.d': '勾選物業相片，系統自動加上中央對角品牌浮水印——AI 修圖也難以去除，無從盜用',
  'promo.step2.t': '發帖',
  'promo.step2.d': '貼文文案自動生成：標題、售租價、地址、短連結一鍵搞定，想改就按「複製文案」',
  'promo.step3.t': '看數',
  'promo.step3.d': '每則貼文自帶追蹤：FB 多少人點擊、物業頁多少人看，後台一目了然',
  'promo.magicBadge': '最強神器',
  'promo.magicTitlePre': '幾張相，變一段',
  'promo.magicTitleHighlight': '專業物業影片。',
  'promo.magicBodyLead': '上載盤相，系統自動生成 1080p 影片：自動配樂、動態字幕（標題／價格／地址）、品牌標誌、',
  'promo.magicBodyBold': '零剪片經驗、零人手',
  'promo.magicBodyTail': '。影片貼文在 FB 的自然觸及遠高於照片貼文，同一份盤源，兩種玩法。',
  'promo.bullet1': '照片輪播＋Ken Burns 動態效果',
  'promo.bullet2': '四種背景音樂風格，一鍵切換',
  'promo.bullet3': '方形 1:1／直式 9:16，FB IG 通用',
  'promo.compareTitle': '算一筆帳給你聽',
  'promo.compare.col1': '請人／人手處理',
  'promo.compare.col2': '這個系統',
  'promo.compare.r1.c0': '出一則貼文',
  'promo.compare.r1.c1': '30–60 分鐘',
  'promo.compare.r1.c2': '10 秒',
  'promo.compare.r2.c0': '一段物業影片',
  'promo.compare.r2.c1': '半天起＋剪片費',
  'promo.compare.r2.c2': '1–2 分鐘自動生成',
  'promo.compare.r3.c0': '相片防盜',
  'promo.compare.r3.c1': '無',
  'promo.compare.r3.c2': '內建 AI 級浮水印',
  'promo.compare.r4.c0': '每盤成效數據',
  'promo.compare.r4.c1': '無／另購工具',
  'promo.compare.r4.c2': '內建，後台直看',
  'promo.compare.r5.c0': '月費成本',
  'promo.compare.r5.c1': '$8,000–15,000',
  'promo.compare.r5.c2': '一個相宜月費',
  'promo.compareNote': '* 系統現正於物業代理實戰運行中',
  'promo.ctaTitlePre': '下個新盤入庫，',
  'promo.ctaTitleHighlight': '10 秒後已在 FB。',
  'promo.ctaSub': '約一節 15 分鐘線上 Demo，用你自己的盤即場試一次。',
  'promo.ctaNote': '雲端系統・資料自持・無長約・專人支援',
  'promo.footer': 'JKD Coding・以無法為有法',
  // ===== Distill 知識蒸餾所（/distill/）=====
  'distill.meta.title': '知識蒸餾所 — 把組織經驗釀成會做事的規則｜JKD Coding',
  'distill.meta.description': 'JKD Coding 知識蒸餾所為大型企業與中小企提供知識萃取服務：把散落在會議、郵件與資深同事腦中的經驗，蒸餾成可執行、可複用、可餵給 AI 員工的規則庫。會議開完那一刻，規則已經上牆。',

  // S1 Hero
  'distill.hero.kicker': 'Be Water, My Friend',
  'distill.hero.title': '知識如水，聚則成形',
  'distill.hero.tagline': '知識蒸餾所 · KNOWLEDGE DISTILLERY',
  'distill.hero.lead': 'JKD Coding 為大型企業與中小企提供知識萃取服務：把散落在會議、郵件與資深同事腦中的經驗，蒸餾成可執行、可複用、可餵給 AI 員工的規則庫——會議開完那一刻，規則已經上牆。',
  'distill.hero.cta1': '預約 30 分鐘診斷',
  'distill.hero.cta2': '方法：蒸餾四步',

  // S2 痛點
  'distill.pain.quote.en': 'Absorb what is useful, discard what is useless.',
  'distill.pain.quote.zh': '吸其有用，棄其無用——李小龍早已說出知識萃取的定義。',
  'distill.pain.heading': '知識蒸發的四種死法',
  'distill.pain.c1.tt': '老師傅退休',
  'distill.pain.c1.ds': '二十年的判斷力，隨一場歡送會歸零——經驗從未離開過他的腦。',
  'distill.pain.c2.tt': '會議記錄墳場',
  'distill.pain.c2.ds': '存了，但沒有人再看。第四千個檔案躺在共用資料夾深處。',
  'distill.pain.c3.tt': 'SOP 石化',
  'distill.pain.c3.ds': '寫完即過時——文件追不上真實做法，新人照著錯的學。',
  'distill.pain.c4.tt': 'AI 空殼',
  'distill.pain.c4.ds': '沒有餵入你們的知識，AI 只是一台禮貌的聊天機械人。',

  // S3 方法四步
  'distill.method.quote.en': "It's not the daily increase but daily decrease — hack away at the unessential.",
  'distill.method.quote.zh': '不是每日增加，而是每日遞減——蒸餾是削法的藝術，規則牆是削出來的，不是囤出來的。',
  'distill.method.heading': '蒸餾循環四步',
  'distill.method.s1.tt': '攔截',
  'distill.method.s1.en': 'Intercept',
  'distill.method.s1.ds': '會議完結當日，記錄直接進爐——不等它蒸發。',
  'distill.method.s1.out': '產出：原始知識入庫',
  'distill.method.s2.tt': '蒸餾',
  'distill.method.s2.en': 'Distill',
  'distill.method.s2.ds': 'AI 加顧問雙刀並落：AI 提煉，顧問削去非本質。',
  'distill.method.s2.out': '產出：候選規則',
  'distill.method.s3.tt': '沉澱',
  'distill.method.s3.en': 'Crystallize',
  'distill.method.s3.ds': '人工批核上牆，每條＝場景＋動作＋負責人。',
  'distill.method.s3.out': '產出：規則牆',
  'distill.method.s4.tt': '復用',
  'distill.method.s4.en': 'Reflow',
  'distill.method.s4.ds': 'AI 員工按規則行事，月度複檢越用越準。',
  'distill.method.s4.out': '產出：組織記憶',

  // S4 主秀
  'distill.show.kicker': 'The Distillery · 主秀',
  'distill.show.heading': '一滴知識的旅程',
  'distill.show.lead': '上層是每天落下來的原始噪音；中間那一道金線，是截住它的手；下層，是留下來會做事的規則。',
  'distill.show.ch1': '會議記錄_v7_最終版（2）.docx',
  'distill.show.ch2': '第 38 次跨部門會議',
  'distill.show.ch3': '「他說改天再談……」',
  'distill.show.ch4': '共用資料夾（4,200 個檔案）',
  'distill.show.ch5': '老師傅下月退休',
  'distill.show.ch6': '郵件往來 217 封',
  'distill.show.funnel': '截 · 蒸 · 沉',
  'distill.show.rule1.tag': 'RULE · 會議',
  'distill.show.rule1.text': '每個會議必須以「誰＋做什麼＋何時」收結，缺一即散會重議。',
  'distill.show.rule2.tag': 'RULE · 對外',
  'distill.show.rule2.text': '凡承諾類回覆，先向內確認再發出——不替公司開口。',
  'distill.show.rule3.tag': 'RULE · 文件',
  'distill.show.rule3.text': '作業準則每 90 日複檢一次，寫的人簽名，改的人留痕。',
  'distill.show.rule4.tag': 'RULE · 傳承',
  'distill.show.rule4.text': '新人三日內讀完規則牆，即可開工。',
  'distill.show.note': '樣例規則為通用示意，非任何客戶實際規則庫內容',

  // S5 證據
  'distill.proof.kicker': 'Proof of Practice · 蒸餾者自我證明',
  'distill.proof.heading': '我們不是教你蒸餾——我們天天在蒸餾',
  'distill.proof.s1.n': '252',
  'distill.proof.s1.l': '條實戰守則持續沉澱於自用治理系統',
  'distill.proof.s2.n': '每週',
  'distill.proof.s2.l': '收割複檢節奏，從不間斷',
  'distill.proof.s3.n': '六語',
  'distill.proof.s3.l': '全站知識治理經驗，直接可移植',
  'distill.proof.quote.en': 'Using no way as way — having no limitation as limitation.',
  'distill.proof.quote.zh': '以無法為有法，以無限為有限——規則由實戰沉澱而成，不是從範本抄襲而來。',

  // S6 適合邊個
  'distill.fit.heading': '這個服務適合誰',
  'distill.fit.f1.tt': '非牟利組織',
  'distill.fit.f1.ds': '捐贈者關係與義工經驗，不再隨幹事更替而流失。',
  'distill.fit.f2.tt': '社會企業',
  'distill.fit.f2.ds': '使命與營運經驗傳承，擴張時不變形。',
  'distill.fit.f3.tt': '中小企業',
  'distill.fit.f3.ds': '把老闆腦中的判斷，變成全公司可用的制度。',
  'distill.fit.f4.tt': '大型企業',
  'distill.fit.f4.ds': '跨部門知識治理：讓每個部門的隱性經驗，變成 AI 員工可執行的規則。',

  // S7 FAQ
  'distill.faq.q1': '知識蒸餾要多久？',
  'distill.faq.a1': '首輪蒸餾以「當日交付」為目標：會議完結當天，該場會議的規則已上牆。整套循環（攔截、蒸餾、沉澱、復用）按組織規模以週為單位推進，並以月度複檢持續循環。',
  'distill.faq.q2': '我們的知識會外洩嗎？',
  'distill.faq.a2': '不會。蒸餾產出的規則屬於你，存放於你的管轄範圍；我們只在服務期內經你授權處理，交付後退出。',
  'distill.faq.q3': '這跟一般 AI 知識管理工具有什麼分別？',
  'distill.faq.a3': '工具只負責儲存，蒸餾負責刪減與成形。沒有「誰＋做什麼＋何時」的規則結構，資料再多也無法被執行——我們交付的是判斷力，不是資料庫。',
  'distill.faq.q4': '蒸餾後的規則如何接駁 AI 員工？',
  'distill.faq.a4': '規則牆是 AI 員工的工作依據：AI 項目經理按規則行事、按規則向內確認，月度複檢時再把新經驗回灌成新規則，形成閉環。',
  'distill.faq.q5': '大型企業與中小企的做法有什麼不同？',
  'distill.faq.a5': '中小企聚焦把老闆腦中的判斷制度化；大型企業則處理跨部門的知識治理——每個部門各自的隱性經驗，統一成互不衝突、可執行的規則集。',
  'distill.faq.q6': '如何開始？',
  'distill.faq.a6': '由一次 30 分鐘診斷開始：盤點你組織中最值錢、也最危險（正在蒸發）的知識資產，再決定蒸餾範圍與節奏。',

  // S8 三段漏斗 CTA
  'distill.funnel.heading': '由一滴噪音，到一隊 AI 員工',
  'distill.funnel.f1.tag': 'STEP 1',
  'distill.funnel.f1.tt': '診斷',
  'distill.funnel.f1.ds': '30 分鐘一對一，盤點你組織裡最值錢、也最危險（正在蒸發）的知識資產。',
  'distill.funnel.f2.tag': 'STEP 2 · 本頁',
  'distill.funnel.f2.tt': '知識蒸餾',
  'distill.funnel.f2.ds': '蒸餾循環四步，規則上牆，知識從此有了形狀。',
  'distill.funnel.f3.tag': 'STEP 3',
  'distill.funnel.f3.tt': 'AI 員工代管',
  'distill.funnel.f3.ds': 'AI 項目經理駐場，按你的規則庫開工——我們賣的是員工，不是軟件。',
  'distill.cta1': 'WhatsApp 直談',
  'distill.cta2': '了解診斷',
  'distill.wa.text': '你好！我想了解 JKD Coding 的知識蒸餾服務。',
  'distill.footer': 'JKD Coding · 以無法為有法',

  // 接駁
  'distill.card.title': '知識萃取',
  'distill.card.desc': '把散落在會議與資深同事腦中的經驗，蒸餾成可執行、可餵給 AI 員工的規則庫。',
  'distill.card.cta': '進入知識蒸餾所',
  'distill.xs.title': '診斷之後：把發現蒸餾成規則',
  'distill.xs.body': '診斷找出瓶頸，知識蒸餾把組織經驗變成可執行、可複用、可餵給 AI 員工的規則庫——會議開完那一刻，規則已經上牆。',
  'distill.xs.cta': '進入知識蒸餾所',

  // ============ 條款及細則 /terms（三 TAB：隱私／退款／交付）============
  'terms.meta.title': '條款及細則 — 隱私・退款・交付政策｜JKD Coding',
  'terms.meta.description': 'JKD Coding（由 Wiseman Consultancy Limited 營運）之條款及細則：隱私政策、退款政策與交付政策，適用於本網站及所有顧問與數位開發服務。',
  'terms.title': '條款及細則',
  'terms.subtitle': '本條款適用於 JKD Coding 網站（jkdcoding.com）及我們提供的所有顧問與數位服務。網站及服務由 Wiseman Consultancy Limited 營運。',
  'terms.updated': '最後更新：2026-10-13',
  'terms.tab.privacy': '隱私政策',
  'terms.tab.refund': '退款政策',
  'terms.tab.delivery': '交付政策',
  'terms.contact': '如有疑問，歡迎透過 WhatsApp +852 5165 1480 與我們聯絡。',

  // — 隱私政策 —
  'terms.privacy.note': '本政策說明 JKD Coding（由 **Wiseman Consultancy Limited** 營運）如何收集、使用及保障你的資料。使用本網站或服務即表示你同意本政策的條款。',
  'terms.privacy.h1': '一、我們收集的資料',
  'terms.privacy.s1': '- **查詢與聯絡資料**：姓名、WhatsApp 號碼、電郵、機構名稱（經診斷預約、WhatsApp 或表單提供）\n- **項目資料**：你提供的業務資料、知識庫內容、網站內容與素材\n- **瀏覽資料**：頁面瀏覽、來源頁與行銷參數（匿名統計，用於改善網站與廣告效果）\n- **付款資料**：我們只保留發票編號與金額，**不會接觸或儲存你的支付工具資料**',
  'terms.privacy.h2': '二、資料用途',
  'terms.privacy.s2': '- 提供、營運及改善我們的顧問與開發服務\n- 報價、項目管理、技術支援與帳務處理\n- 重要服務通知（預約確認、交付安排、安全警示）',
  'terms.privacy.h3': '三、第三方處理（AI 引擎）',
  'terms.privacy.s3': '為提供 AI 相關服務，客戶提供的內容可能傳送至我們採用的大型語言模型服務商（包括 DeepSeek、Z.ai 等）處理。該等服務商按其自身隱私政策處理資料；我們只傳送完成工作所需的內容，並持續審視其資料保障安排。',
  'terms.privacy.h4': '四、資料保留',
  'terms.privacy.s4': '- 查詢與對話紀錄：保留約 24 個月後清理\n- 項目檔案：交付後保留 90 日供修復與支援，其後應要求刪除或自動清理',
  'terms.privacy.h5': '五、我們不會做的事',
  'terms.privacy.s5': '- 不出售、不租借你的任何資料\n- 不將你或你客戶的資料用於第三方推銷\n- 除法律要求或提供服務所必需（如 AI 引擎、託管與支付服務商）外，不向第三方披露',
  'terms.privacy.h6': '六、你的權利',
  'terms.privacy.s6': '你有權查閱、更正或刪除你的個人資料。透過 WhatsApp +852 5165 1480 提出要求，我們將於 **14 日內**回應。我們的處理方式符合《個人資料（私隱）條例》（香港法例第 486 章）。',
  'terms.privacy.h7': '七、政策更新',
  'terms.privacy.s7': '如有重大變更，我們會於本頁公佈並更新「最後更新」日期。重大影響服務使用的變更會另行通知。',

  // — 退款政策 —
  'terms.refund.note': 'JKD Coding 提供的是數位顧問與開發服務（非實體貨品），所有價格以港幣計算。我們鼓勵你先預約**免費診斷**（30 分鐘一對一），了解清楚再決定付費。',
  'terms.refund.h1': '一、免費診斷',
  'terms.refund.s1': '診斷完全不收費，亦無銷售壓力；所有收費項目均在診斷後報價，經你書面確認方才開始收費。',
  'terms.refund.h2': '二、開工前取消',
  'terms.refund.s2': '項目確認後、尚未開工前取消：已繳款項**全數退回**；如已為你產生第三方成本（域名、授權、雲端資源等），憑單據實報實銷扣除。',
  'terms.refund.h3': '三、現成方案與元件庫',
  'terms.refund.s3': '付款後 **7 日內**，如服務因我們的原因未能交付或無法正常運作，且我們無法在合理時間內修復，你可申請**全額退款**。已成功交付並正常運作者，視為已完成，不設退款。',
  'terms.refund.h4': '四、訂製項目（里程碑制）',
  'terms.refund.s4': '- 訂製項目按里程碑收費：**已開工的里程碑**按實際完成進度結算，**未開工的里程碑**可退\n- 中途取消：已完成並通過驗收的工作不設退款，未完成部分按比例退還\n- 交付後的修改需求屬新增範圍，另行報價',
  'terms.refund.h5': '五、錯誤扣款',
  'terms.refund.s5': '如發現重複扣款或金額錯誤，經核實後將於 **7 個工作日內**全額原路退回。',
  'terms.refund.h6': '六、申請方式',
  'terms.refund.s6': 'WhatsApp +852 5165 1480（請提供發票編號）。所有申請於 **7 個工作日內**處理，款項經原支付渠道退回。',

  // — 交付政策 —
  'terms.delivery.note': 'JKD Coding 提供的是純數位服務——**無實體貨運**，所有交付均以電子方式進行，不產生運費。',
  'terms.delivery.h1': '一、交付時限',
  'terms.delivery.s1': '- **現成方案**：確認需求及付款後最快 30 分鐘完成部署（辦公時間內）\n- **元件庫**：授權與文件於付款後 1 個工作日內以電郵／WhatsApp 發送\n- **訂製項目**：按合約里程碑交付，一般 6–8 週上線\n- 非辦公時間的委託將於下一個辦公時段處理；所有查詢 24 小時內回覆',
  'terms.delivery.h2': '二、交付內容',
  'terms.delivery.s2': '按方案而定，一般包括：網站／系統的存取權限、原始碼或部署環境、設定與使用指引、技術支援聯絡渠道。',
  'terms.delivery.h3': '三、交付方式',
  'terms.delivery.s3': '全部以電子方式交付（網頁、電郵、WhatsApp）。完成部署並通過雙方驗收後，服務即視為已送達並開始提供。',
  'terms.delivery.h4': '四、交付延誤',
  'terms.delivery.s4': '如超過承諾時限仍未交付，你可選擇**盡快補交**，或按[退款政策](#refund)申請退款。',

  // — footer 條款連結 —
  'footer.termsLink': '條款及細則',
} as const;
